import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import {
  IAddCallParticipantRequest,
  ICallScribeParticipant,
  ICallScribeTeammate,
} from 'services/callScribe/types';

export const addParticipant = (
  callId: number,
  body: IAddCallParticipantRequest,
): IResponse<ICallScribeParticipant> =>
  axiosInstance.request({
    method: 'POST',
    url: `call-scribe/calls/${callId}/participants`,
    data: body,
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const muteParticipant = (
  callId: number,
  participantId: number,
  muted: boolean,
): IResponse<unknown> =>
  axiosInstance.request({
    method: 'PATCH',
    url: `call-scribe/calls/${callId}/participants/${participantId}`,
    data: { muted },
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const removeParticipant = (
  callId: number,
  participantId: number,
): IResponse<unknown> =>
  axiosInstance.request({
    method: 'DELETE',
    url: `call-scribe/calls/${callId}/participants/${participantId}`,
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const getTeammates = (): IResponse<ICallScribeTeammate[]> =>
  axiosInstance.request({
    method: 'GET',
    url: 'call-scribe/teammates',
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    skipErrorSnackbar: true,
  });
